export default __webpack_public_path__ + "static/media/DolbyCinema New Arabic R4-02.feb1e608.png";